export const getCurrentTimeZoneOffset = (): number => {
  return (new Date().getTimezoneOffset() / 60) * -1
}
